import { render } from "./TraderOperators.vue?vue&type=template&id=1639e79c&ts=true"
import script from "./TraderOperators.vue?vue&type=script&lang=ts"
export * from "./TraderOperators.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__